import { useCurrentAccount } from './useCurrentAccount';
import { useIsInImpersonateUser } from './useIsInImpersonateUser';

export const useCanImpersonate = (): boolean => {
  const { account } = useCurrentAccount();
  const isInImpersonateUser = useIsInImpersonateUser();
  return (account?.isGlobalAdmin() ?? false) || !!isInImpersonateUser;
};
